import RequestWithdrawPageContainer from "../../Component/Withdraw/RequestWithdraw/RequestWithdraw"

const RequestWithdrawPage = () => {
  return (
    <div className='page-body'>
      <RequestWithdrawPageContainer />
    </div>
  )
}

export default RequestWithdrawPage